// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchFieldWrapper, {
    SearchFieldWrapperStyles,
} from "@insite/content-library/Widgets/OrderHistory/SearchFieldWrapper";
import Select, { SelectProps } from "@insite/mobius/Select";
import { SearchFieldOptionsModel as selectOptionsModel } from "@store/Framework/Types/SearchFieldOptionsModel";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationState) => {
    const parameter = state.pages.orderHistory.getOrdersParameter;
    return {
        ordersDataView: getOrdersDataView(state, parameter),
        parameter,
    };
};

const mapDispatchToProps = {
    updateSearchFields,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface OrderHistoryDeliveryStatusStyles {
    select?: SelectProps;
    wrapper?: SearchFieldWrapperStyles;
}

export const orderHistoryDeliveryStatusStyles: OrderHistoryDeliveryStatusStyles = {};

const styles = orderHistoryDeliveryStatusStyles;

const OrderHistorySearchFieldDeliveryStatus: React.FunctionComponent<Props> = props => {
    let selectVal = props.parameter.additionalQueryStringParameters?.deliveryStatusFilter || "";
    const selectOptions: selectOptionsModel[] =
        "properties" in props.ordersDataView && "orderTypeList" in (props.ordersDataView as any).properties
            ? JSON.parse(props.ordersDataView.properties.deliveryStatusList)
            : [];

    const handleSelectChange = (event: React.FormEvent<HTMLSelectElement>) => {
        if (event.currentTarget.value) {
            props.updateSearchFields({
                _deliveryStatusFilter: event.currentTarget.value,
                additionalQueryStringParameters: {
                    deliveryStatusFilter: event.currentTarget.value,
                },
            } as any);
        } else {
            props.updateSearchFields({
                _deliveryStatusFilter: undefined,
                additionalQueryStringParameters: {
                    deliveryStatusFilter: undefined,
                },
            } as any);
            selectVal = "";
        }
    };

    return (
        <SearchFieldWrapper extendedStyles={styles.wrapper}>
            {selectOptions && (
                <Select
                    label={translate("Delivery Status")}
                    value={selectVal}
                    onChange={handleSelectChange}
                    data-test-selector="orderHistory_filterDelivery"
                >
                    <option value="">{translate("Select")}</option>
                    {selectOptions.map(item => (
                        <option key={item.key} value={item.key}>
                            {item.value}
                        </option>
                    ))}
                </Select>
            )}
        </SearchFieldWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(OrderHistorySearchFieldDeliveryStatus),
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "Delivery Status",
    },
};

export default widgetModule;
